import gql from 'graphql-tag';
import { STORE_SITE_FRAGMENT } from './fragments.graphql';

export const CREATE_STORE_SITE = gql`
  mutation CreateStoreSite($input: CreateStoreSiteInput!) {
    createStoreSite(input: $input) {
      id
      name
      identifier
      sellerChannel {
          id
          code
          token
      }
    }
  }
`;

export const GetCollectionDocument = gql`
  query GetCollection($id: ID!) {
    collection(id: $id) {
      id
      name
    }
  }
`;

export const GET_COLLECTION_BY_ID = gql`
    query GetCollectionById($id: ID!) {
        collection(id: $id) {
            id
            name
            slug
            parent {
                id
                name
                slug
            }
        }
    }
`;

export const GetAllStoreSitesDocument = gql`
  query GetStoreSites($options: StoreSiteListOptions) {
    storeSites(options: $options) {
      items {
        ...StoreSite
      }
      totalItems
    }
  }
  ${STORE_SITE_FRAGMENT}
`;

export const GET_ACTIVE_CHANNEL_WITH_SELLER_CUSTOM_FIELDS = gql`
    query GetActiveChannelWithSellerCustomFields {
        activeChannel {
            id
            code
            seller {
                id
                customFields
            }
        }
    }
`;

export const GET_SELLER_OWNER_ADMIN_USER_ID = gql`
    query GetSellerOwnerAdminUserId($id: ID!) {
        seller(id: $id) {
            id
            customFields
        }
    }
`;

export const GetStoreSiteDocument = gql`
  query GetStoreSite($id: ID!) {
    storeSite(id: $id) {
      ...StoreSite
      sellerChannel {
        id
        code
      }
    }
  }
  ${STORE_SITE_FRAGMENT}
`;

export const GetStoreSiteDetailByChannelDocument = gql`
  query GetStoreSiteDetailByChannel {
    getStoreSiteByChannel {
      ...StoreSite
      sellerChannel {
        id
        code
        customFields {
          subscriptionEnabled
        }
      }
    }
  }
  ${STORE_SITE_FRAGMENT}
`;

export const updateStoreSiteDocument = gql`
  mutation UpdateStoreSite($input: UpdateStoreSiteInput!) {
    updateStoreSite(input: $input) {
      ...StoreSite
    }
  }
  ${STORE_SITE_FRAGMENT}
`;

export const PUBLISH_SITE_REVISION = gql`
    mutation PublishSiteRevision($identifier: String!) {
        publishSiteRevision(identifier: $identifier) {
            id
            version
            siteRoutes {
                slug
                name
                type
            }
        }
    }
`;

export const GET_STORE_SITE_VERSIONS = gql`
    query GetStoreSiteVersions($storeSiteId: ID!, $options: SiteVersionListOptions) {
        storeSiteVersions(storeSiteId: $storeSiteId, options: $options) {
            items {
                id
                createdAt
                version
                label
            }
            totalItems
        }
    }
`;

export const SAVE_STORE_SITE_VERSION = gql`
    mutation SaveStoreSiteVersion($id: ID!, $label: String) {
        saveStoreSiteVersion(id: $id, label: $label) {
            id
            version
            label
        }
    }
`;

export const RESTORE_STORE_SITE_VERSION = gql`
    mutation RestoreStoreSiteVersion($id: ID!, $revisionId: ID!, $options: SiteVersionRestoreOptionsInput) {
        restoreStoreSiteVersion(id: $id, revisionId: $revisionId, options: $options) {
            id
        }
    }
`;

export const DELETE_STORE_SITE_VERSION = gql`
    mutation DeleteStoreSiteVersion($id: ID!, $revisionId: ID!) {
        deleteStoreSiteVersion(id: $id, revisionId: $revisionId)
    }
`;

export const GET_PRODUCTS = gql`
    query GetProducts($options: ProductListOptions) {
        products(options: $options) {
            items {
                id
                name
                slug
            }
            totalItems
        }
    }
`;

export const GET_REVIEWS_FOR_PRODUCT = gql`
    query GetReviewForProduct($productId: ID!, $options: ProductReviewListOptions) {
        product(id: $productId) {
            id
            reviews(options: $options) {
                items {
                    id
                    summary
                    body
                    rating
                    authorName
                    state
                }
                totalItems
            }
        }
    }
`;

export const GET_PRODUCT_REVIEW = gql`
    query GetProductReview($productReviewId: ID!) {
        productReview(id: $productReviewId) {
            id
            summary
            body
            rating
            authorName
            state
            product {
                id
                name
                slug
            }
        }
    }
`;


export const ARCHIVE_STORE_SITE_DOCUMENT = gql`
    mutation ArchiveStoreSite($id: ID!) {
        archiveStoreSite(id: $id)
    }
`;

export const GET_STORE_SITE_HISTORY = gql`
    query GetStoreSiteHistory($storeSiteId: ID!, $options: StoreSiteHistoryEntryListOptions) {
        storeSiteHistory(storeSiteId: $storeSiteId, options: $options) {
            items {
                id
                createdAt
                type
                data
                isPublic
            }
            totalItems
        }
    }
`;

export const ADD_STORE_SITE_HISTORY_NOTE = gql`
    mutation AddStoreSiteHistoryNote($storeSiteId: ID!, $note: String!, $isPublic: Boolean) {
        addStoreSiteHistoryNote(storeSiteId: $storeSiteId, note: $note, isPublic: $isPublic) {
            id
            createdAt
            type
            data
            isPublic
        }
    }
`;

export const PREVIEW_STORE_SITE = gql`
    mutation PreviewStoreSite($id: ID!) {
        previewStoreSite(id: $id) {
            previewUrl
            storeSite { id status }
        }
    }
`;

export const PUBLISH_STORE_SITE_FOR_REVIEW = gql`
    mutation PublishStoreSiteForReview($id: ID!) {
        publishStoreSiteForReview(id: $id) { id status }
    }
`;

export const LAUNCH_STORE_SITE = gql`
    mutation LaunchStoreSite($id: ID!) {
        launchStoreSite(id: $id) { id status }
    }
`;
